import { SEARCHING_START } from "../types";

export const setSearchingStart = (data) => ({
    type: SEARCHING_START,
    payload: data
})